import { render } from "./RenameProcessModal.vue?vue&type=template&id=12e464a6&scoped=true&ts=true"
import script from "./RenameProcessModal.vue?vue&type=script&lang=ts"
export * from "./RenameProcessModal.vue?vue&type=script&lang=ts"

import "./RenameProcessModal.vue?vue&type=style&index=0&id=12e464a6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e464a6"]])

export default __exports__